/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

export function createEcommerceImpression($item){
    return {
        'id': $item.data('idaggregate'),
        'name': $item.find('.brand-name').text()+' '+$item.find('.model-name').text(),
        'price': $item.find('.actual-price .price-value').text().trim().replace(' ', ''),
        'brand': $item.find('.brand-name').text(),
        'category': $item.find('.version-name').text(),
        'list': '',
        'position': $item.parent().index(),
    };
}

export function sendEcommerceTags($items) {
    if(!$items.length){
        return;
    }

    let $impressions = [];
    $items.each(function(){
        let $item = $(this).find('.offer-thumb');

        $impressions.push(createEcommerceImpression($item));
    });

    let dataLayer = window.dataLayer || [];
    dataLayer.push({
        'ecommerce': {
            'currencyCode': 'PLN',
            'impressions': $impressions
        }
    });
}
